import { useEffect, useState } from 'react';
import { textos } from '../textos';
import { haySesionDeEscaneoAbierta } from '../features/movements/sesion-local';

/**
 * Aviso de versión nueva. Nunca recarga solo: en campo un recarga a mitad de
 * una sesión de escaneo perdería lecturas no confirmadas.
 */
export function AvisoVersion(): React.JSX.Element | null {
  const [registro, setRegistro] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return undefined;
    let cancelado = false;
    void navigator.serviceWorker.register('/sw.js').then((reg) => {
      if (cancelado) return;
      const avisar = (): void => {
        if (reg.waiting && !haySesionDeEscaneoAbierta()) setRegistro(reg);
      };
      avisar();
      reg.addEventListener('updatefound', () => {
        const inst = reg.installing;
        inst?.addEventListener('statechange', () => {
          if (inst.state === 'installed') avisar();
        });
      });
    });
    return () => {
      cancelado = true;
    };
  }, []);

  if (!registro?.waiting) return null;

  return (
    <div className="fixed bottom-20 left-0 right-0 z-30 flex justify-center px-4">
      <div className="flex max-w-md items-center gap-3 rounded-brand bg-brand-surface-2 px-4 py-3 text-brand-text shadow">
        <p className="text-sm">{textos.pwa.nuevaVersion}</p>
        <button
          type="button"
          className="min-h-tactil rounded-brand bg-brand-primary px-3 text-brand-primary-fg"
          onClick={() => {
            registro.waiting?.postMessage({ tipo: 'saltar-espera' });
            window.location.reload();
          }}
        >
          {textos.pwa.actualizar}
        </button>
      </div>
    </div>
  );
}
